import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "@/styles/reset.scss";
import "@/styles/variables.css";
import "amfe-flexible";
import globalMethods from "@/utils/globalMethods";
import "@/permission";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import VueCookies from "vue-cookies";

window._AMapSecurityConfig = {
  securityJsCode: "4f1c1aed898e819589de8ec2a28ccf59",
};

import { dictType_list } from "@/api/tool"
import tool from "@/utils/tool"
Vue.prototype.dictTypeList = dictType_list;
Vue.prototype.selectDictLabel = tool.selectDictLabel;
Vue.prototype.parseTime = tool.parseTime;

//全局挂载组件
import swiperTab from "@/components/swiper-tab";
import navTab from "@/components/nav-tab";
Vue.component("swiper-tab", swiperTab);
Vue.component("nav-tab", navTab);

Vue.config.productionTip = false;
Vue.use(globalMethods);
Vue.use(ElementUI);
Vue.use(VueCookies);
new Vue({
  router,
  store,
  render: function (h) {
    return h(App);
  },
}).$mount("#app");
